type Listener = () => void

const listeners = new Set<Listener>()

export const announceMessagesSent = () => {
  listeners.forEach((listener) => listener())
}

export const onMessagesSent = (listener: Listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
